import HeroBanner from "../../components/RoyalLuxury/HeroBanner";
import BrandPhilosophy from "../../components/RoyalLuxury/BrandPhilosophy";
import ShopByCategory from "../../components/RoyalLuxury/ShopByCategory";
import SignatureCollection from "../../components/RoyalLuxury/SignatureCollection";
import WhyRoyalLuxury from "../../components/RoyalLuxury/WhyRoyalLuxury";
import FormulaSpotlight from "../../components/RoyalLuxury/FormulaSpotlight";
import Faq from "../../components/RoyalLuxury/Faq";
import Cta from "../../components/RoyalLuxury/Cta";
import BestSellers from "../../components/RoyalLuxury/BestSellers";
import ShinePromo from "../../components/RoyalLuxury/ShinePromo";
import CmsPageHero from "../../components/CmsPageHero";

const RoyalLuxuryPage = () => (
  <main>
    <CmsPageHero slug="royal-luxury"><HeroBanner /></CmsPageHero>
    <BrandPhilosophy />
    <ShopByCategory />
    <SignatureCollection />
    <WhyRoyalLuxury />
    <FormulaSpotlight />
    <Faq />
    <Cta />
    <BestSellers />
    <ShinePromo />
  </main>
);

export default RoyalLuxuryPage;
